'use es6';

import autolinker from 'autolinker';
export const autoLink = html => autolinker.link(html, {
  stripPrefix: false
});